import React, { useState, useEffect, useRef } from 'react';
import './TextTranslate.css';
import { loadGoogleFont } from '../utils/loadGoogleFont';

const languages = [
  { code: 'en', name: 'English' },
  { code: 'hi', name: 'Hindi' },
  { code: 'gu', name: 'Gujarati' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },
  { code: 'zh', name: 'Chinese (Simplified)' },
  { code: 'ja', name: 'Japanese' },
  { code: 'ar', name: 'Arabic' }
];

const fonts = [
  'Roboto',
  'Montserrat',
  'Playfair Display',
  'Poppins',
  'Raleway',
  'Oswald',
  'Lobster',
  'Pacifico',
  'Dancing Script',
  'Great Vibes',
  'Abril Fatface',
  'Anton',
  'Bebas Neue'
];

const TextTranslate = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [targetLang, setTargetLang] = useState('hi');
  const [fontFamily, setFontFamily] = useState('Roboto');
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState('translate');
  const resultRef = useRef();

  const handleAction = async () => {
    if (!text.trim()) {
      alert('Please enter text.');
      return;
    }

    if (mode === 'translate') {
      setLoading(true);
      try {
        const res = await fetch(
          `https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&tl=${targetLang}&dt=t&q=${encodeURIComponent(text)}`
        );
        const data = await res.json();
        const translatedText = data[0].map((item) => item[0]).join(' ');
        setResult(translatedText);
      } catch (err) {
        console.error(err);
        alert('Translation failed.');
      } finally {
        setLoading(false);
      }
    } else {
      setResult(text);
      loadGoogleFont(fontFamily);
    }
  };

  useEffect(() => {
    if (mode === 'font') {
      loadGoogleFont(fontFamily);
    }
  }, [fontFamily, mode]);

  const handleCopy = () => {
    const range = document.createRange();
    range.selectNode(resultRef.current);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    alert('Styled text copied!');
    selection.removeAllRanges();
  };

  return (
    <div className="translate-container">
      <h2>Text Translate & Font Styling</h2>

      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Enter text here..."
        className="translate-textarea"
      />

      <div className="translate-toggle">
        <button
          onClick={() => setMode('translate')}
          className={mode === 'translate' ? 'active' : ''}
        >
          🌐 Translate
        </button>
        <button
          onClick={() => setMode('font')}
          className={mode === 'font' ? 'active' : ''}
        >
          🎨 Font
        </button>
      </div>

      {mode === 'translate' && (
        <div className="translate-controls">
          <label>Select Language:</label>
          <select
            value={targetLang}
            onChange={(e) => setTargetLang(e.target.value)}
            className="translate-select"
          >
            {languages.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </select>

          <button
            onClick={handleAction}
            className="translate-btn"
            disabled={loading}
          >
            {loading ? 'Translating...' : 'Translate'}
          </button>
        </div>
      )}

      {mode === 'font' && (
        <div className="translate-controls">
          <label>Select Font:</label>
          <select
            value={fontFamily}
            onChange={(e) => setFontFamily(e.target.value)}
            className="translate-select"
          >
            {fonts.map((font) => (
              <option key={font} value={font}>
                {font}
              </option>
            ))}
          </select>

          <button onClick={handleAction} className="translate-btn">
            Change Font
          </button>
        </div>
      )}

      {result && (
        <div className="translate-result">
          <div
            ref={resultRef}
            contentEditable
            suppressContentEditableWarning
            className="translate-output"
            style={{
              fontFamily: `'${fontFamily}', sans-serif`,
              border: '1px solid #ccc',
              padding: '8px',
              minHeight: '60px',
              color: 'black'
            }}
          >
            {result}
          </div>
          <button onClick={handleCopy} className="copy-btn">
            Copy Styled 📋
          </button>
        </div>
      )}
    </div>
  );
};

export default TextTranslate;
